import { toast } from 'src/components/ui/toast';

export async function persistNoteChange(params: {
  run: () => Promise<void>;
  onSuccess: () => void;
  successMessage: string;
  fallbackError: string;
}): Promise<void> {
  try {
    await params.run();
    toast.success(params.successMessage);
    params.onSuccess();
  } catch (error) {
    toast.error(error instanceof Error ? error.message : params.fallbackError);
  }
}
